import styled from 'styled-components';

export const StyledButton = styled.button`
    width: 100%;
    color: #F9F9F9;
    background-color: rgba(215, 62, 103, 1);
    padding: 12px 32px;
    margin: ${({margin}) => margin || ''};
    font-size: 16px;
    min-width: 64px;
    box-sizing: border-box;
    border: solid rgba(24, 57, 129, 1) 0px;
    border-radius: 20px;
    cursor: pointer;
    outline: 0;
     text-decoration: none;
    -webkit-appearance: none;
    -webkit-tap-highlight-color: transparent;
    box-shadow: 0px 3px 9px 0px rgba(0,0,0,0.23);
    transition: border-color 0.4s ease 0s, background-color 0.4s ease 0s;
 
    &:hover {
        background-color: rgba(149, 140, 214, 1);
    }
`;

export const Href = styled.a`
    width: 100%;
    text-decoration: none;
    color: inherit;
`;
